(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desktop-navigation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const adjustPromoImageHeights = (panel) => {
      if (!panel) return;
      const content = panel.querySelector('[class*="__panel-content"]');
      if (!content || !content.classList.contains('has-extras')) return;

      const columns = content.querySelector('[data-nav-columns]');
      const extras = content.querySelector('[data-nav-extras]');
      if (!columns || !extras) return;

      const promoItems = [...extras.querySelectorAll('[data-promo-item]')].filter((item) => !item.classList.contains('is-auto-hidden'));
      if (!promoItems.length) return;

      const targetHeight = Math.max(0, columns.getBoundingClientRect().height);

      if (!targetHeight) return;

      promoItems.forEach((item) => {
        const image = item.querySelector('.desktop-nav-extra-image');
        if (!image) return;
        const configuredMinImageHeight = parseFloat(item.dataset.promoMinImageHeight || '0') || 0;

        // Measure card body/chrome first, then allocate remaining space to image.
        item.style.minHeight = '0px';
        item.style.height = 'auto';
        image.style.height = '0px';
        const bodyHeight = item.getBoundingClientRect().height;

        const imageHeightFromMenu = Math.max(0, targetHeight - bodyHeight);
        const nextImageHeight = Math.max(configuredMinImageHeight, imageHeightFromMenu);
        item.style.minHeight = '0px';
        item.style.height = `${Math.floor(bodyHeight + nextImageHeight)}px`;
        image.style.height = `${Math.floor(nextImageHeight)}px`;
      });
    };

    const adjustExtrasForPanel = (panel) => {
      if (!panel) return;
      const content = panel.querySelector('[class*="__panel-content"]');
      if (!content || !content.classList.contains('has-extras')) return;

      const columns = content.querySelector('[data-nav-columns]');
      const extras = content.querySelector('[data-nav-extras]');
      if (!columns || !extras) return;

      const configuredMenuHeight = parseInt(panel.dataset.submenuMaxHeight || '', 10);
      if (configuredMenuHeight && configuredMenuHeight > 0) {
        content.style.minHeight = `${configuredMenuHeight}px`;
        columns.style.minHeight = `${configuredMenuHeight}px`;
        extras.style.minHeight = `${configuredMenuHeight}px`;
      } else {
        content.style.removeProperty('min-height');
        columns.style.removeProperty('min-height');
        extras.style.removeProperty('min-height');
      }

      const promoItems = [...extras.querySelectorAll('[data-promo-item]')];
      promoItems.forEach((item) => item.classList.remove('is-auto-hidden'));
      extras.style.maxWidth = '';

      const getRects = () => {
        const columnsRect = columns.getBoundingClientRect();
        const columnChildren = [...columns.children];
        let columnsVisualRight = columnsRect.right;
        columnChildren.forEach((child) => {
          const childRect = child.getBoundingClientRect();
          if (childRect.right > columnsVisualRight) columnsVisualRight = childRect.right;
        });

        const extrasRect = extras.getBoundingClientRect();
        const visibleExtraItems = [...extras.children].filter((item) => !item.classList.contains('is-auto-hidden'));
        let extrasVisualLeft = extrasRect.left;
        let extrasVisualRight = extrasRect.right;
        if (visibleExtraItems.length) {
          const measuredRects = visibleExtraItems.map((item) => item.getBoundingClientRect());
          extrasVisualLeft = measuredRects[0].left;
          extrasVisualRight = measuredRects[measuredRects.length - 1].right;
        }

        const contentRect = content.getBoundingClientRect();
        return { columnsVisualRight, extrasVisualLeft, extrasVisualRight, contentRect };
      };

      const hasOverlap = () => {
        const { columnsVisualRight, extrasVisualLeft, extrasVisualRight, contentRect } = getRects();
        const contentStyles = window.getComputedStyle(content);
        const extrasStyles = window.getComputedStyle(extras);
        const layoutGap = parseFloat(contentStyles.columnGap || contentStyles.gap || '0') || 0;
        const extrasPaddingLeft = parseFloat(extrasStyles.paddingLeft || '0') || 0;
        const minDistance = layoutGap + extrasPaddingLeft;
        const overlapsColumns = extrasVisualLeft < (columnsVisualRight + minDistance - 0.5);
        const overflowsContent = extrasVisualRight > (contentRect.right + 0.5);
        return overlapsColumns || overflowsContent;
      };

      let guard = 0;
      while (hasOverlap() && guard < promoItems.length) {
        const visiblePromos = promoItems.filter((item) => !item.classList.contains('is-auto-hidden'));
        if (visiblePromos.length === 0) break;
        visiblePromos[visiblePromos.length - 1].classList.add('is-auto-hidden');
        guard += 1;
      }

      adjustPromoImageHeights(panel);
    };

    const adjustAllExtras = (scope = document) => {
      const panels = scope.querySelectorAll('[class*="__panel"][role="region"]');
      panels.forEach((panel) => adjustExtrasForPanel(panel));
    };

    const adjustTopMenuGap = (sectionEl, nav) => {
      if (!sectionEl || !nav) return;
      const menu = nav.querySelector('[class*="__menu"]');
      if (!menu) return;

      const navItems = [...nav.querySelectorAll('[data-nav-item]')];
      const controls = navItems
        .map((item) => item.querySelector('button, a'))
        .filter(Boolean);
      if (!controls.length) return;

      const configuredGap = parseFloat(
        window.getComputedStyle(sectionEl).getPropertyValue('--desktop-nav-item-gap') || '0'
      ) || 0;
      sectionEl.style.setProperty('--desktop-nav-current-item-gap', `${configuredGap}px`);

      if (!window.matchMedia('(min-width: 990px)').matches) return;

      const minimumGap = configuredGap > 10 ? 10 : configuredGap;
      if (controls.length < 2) {
        sectionEl.style.setProperty('--desktop-nav-current-item-gap', `${configuredGap}px`);
        return;
      }

      const controlsWidth = controls.reduce((sum, control) => (
        sum + control.getBoundingClientRect().width
      ), 0);
      const availableWidth = menu.clientWidth;
      const requiredGap = (availableWidth - controlsWidth) / (controls.length - 1);
      const nextGap = Math.min(configuredGap, Math.max(minimumGap, requiredGap));
      sectionEl.style.setProperty('--desktop-nav-current-item-gap', `${nextGap}px`);
    };

    const closeNav = (sectionEl, nav) => {
      const navItems = nav.querySelectorAll('[data-nav-item]');
      navItems.forEach((item) => {
        item.classList.remove('is-open');
        const trigger = item.querySelector('button[aria-expanded]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    };

    const openItem = (sectionEl, nav, item, trigger) => {
      closeNav(sectionEl, nav);
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      adjustExtrasForPanel(item.querySelector('[class*="__panel"]'));
    };

    const initSection = (sectionEl) => {
      if (!sectionEl || sectionEl.dataset.desktopNavInitialized === 'true') return;
      sectionEl.dataset.desktopNavInitialized = 'true';

      const nav = sectionEl.querySelector('[data-desktop-nav]');
      if (!nav) return;
      const triggerMode = sectionEl.dataset.navTriggerMode || 'hover';

      const navItems = [...nav.querySelectorAll('[data-nav-item]')];
      navItems.forEach((item) => {
        const trigger = item.querySelector('button[aria-expanded]');

        if (triggerMode == 'hover') {
          item.addEventListener('mouseenter', () => {
            if (!window.matchMedia('(min-width: 990px)').matches) return;
            if (trigger) {
              openItem(sectionEl, nav, item, trigger);
            } else {
              closeNav(sectionEl, nav);
            }
          });
        }

        if (triggerMode == 'click' && trigger) {
          trigger.addEventListener('click', () => {
            const wasOpen = item.classList.contains('is-open');
            closeNav(sectionEl, nav);
            if (!wasOpen) {
              openItem(sectionEl, nav, item, trigger);
            }
          });
        }
      });

      if (triggerMode == 'hover') {
        sectionEl.addEventListener('mouseleave', () => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          closeNav(sectionEl, nav);
        });
      }

      const configuredPanels = sectionEl.querySelectorAll('[data-submenu-max-height]');
      configuredPanels.forEach((panel) => {
        const maxHeight = parseInt(panel.dataset.submenuMaxHeight || '', 10);
        const columns = parseInt(panel.dataset.submenuColumns || '2', 10);
        if (!maxHeight || maxHeight < 40) return;

        const menuColumns = panel.querySelector('[data-nav-columns]');
        if (menuColumns) {
          menuColumns.style.minHeight = `${maxHeight}px`;
        }

        const subLists = panel.querySelectorAll('.desktop-nav-sub-list');
        subLists.forEach((list) => {
          list.style.removeProperty('--desktop-nav-sub-max-height');
          list.style.removeProperty('--desktop-nav-sub-columns');
          list.classList.remove('is-multi-col');

          // Measure natural height first; then split into columns if it exceeds the configured limit.
          if (list.scrollHeight > maxHeight) {
            list.style.setProperty('--desktop-nav-sub-max-height', `${maxHeight}px`);
            list.style.setProperty('--desktop-nav-sub-columns', `${Math.max(2, columns)}`);
            list.classList.add('is-multi-col');
          }
        });
      });

      adjustTopMenuGap(sectionEl, nav);
      adjustAllExtras(sectionEl);

      sectionEl.querySelectorAll('[role="region"] img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', () => {
          const panel = img.closest('[role="region"]');
          adjustExtrasForPanel(panel);
        }, { once: true });
      });
    };

    const initAll = (root = document) => {
      if (root.matches && root.matches('[data-desktop-nav-section]')) initSection(root);
      if (root.querySelectorAll) {
        root.querySelectorAll('[data-desktop-nav-section]').forEach((sectionEl) => initSection(sectionEl));
      }
    };

    initAll(document);

    if (!window.__desktopNavGlobalsBound) {
      window.__desktopNavGlobalsBound = true;

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-desktop-nav]')) return;
        document.querySelectorAll('[data-desktop-nav-section]').forEach((sectionEl) => {
          const nav = sectionEl.querySelector('[data-desktop-nav]');
          if (nav) closeNav(sectionEl, nav);
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('[data-desktop-nav-section]').forEach((sectionEl) => {
          const nav = sectionEl.querySelector('[data-desktop-nav]');
          if (nav) closeNav(sectionEl, nav);
        });
      });

      document.addEventListener('shopify:section:load', (event) => {
        initAll(event.target);
      });

      window.addEventListener('resize', () => {
        document.querySelectorAll('[data-desktop-nav-section]').forEach((sectionEl) => {
          const nav = sectionEl.querySelector('[data-desktop-nav]');
          if (nav) adjustTopMenuGap(sectionEl, nav);
        });
        adjustAllExtras(document);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        this.setupToggleListeners();
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      setupToggleListeners() {
        this.querySelectorAll('details').forEach((detail) => {
          detail.addEventListener('toggle', function () {
            if (this.open) {
              document.querySelectorAll('footer-menu details[open]').forEach((openDetail) => {
                if (openDetail !== this) {
                  openDetail.removeAttribute('open');
                }
              });
            }
          });
        });
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-with-sidebar"]) return;
  try {
    
  const iframes = document.querySelectorAll('.article-content iframe');
  iframes.forEach((iframe) => {
    const container = document.createElement('div');
    container.className = 'rte__video-wrapper';
    iframe.parentNode.insertBefore(container, iframe);
    container.appendChild(iframe);
  });

  } catch(e) { console.error(e); }
})();
})();
